import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';

import * as Showdown from 'showdown';

import {Language} from 'classes/language';
import {Tip} from 'shared/models/tips/tip';
import {Thesis} from 'shared/classes/thesis';
import {TranslatedText} from 'shared/models/translated-text';
import {ThesisDetailsService} from './services/thesis-details.service';

@Component({
  selector: 'thesis-details',
  templateUrl: './thesis-details.component.html',
  styleUrls: ['./thesis-details.component.css'],
})

export class ThesisDetailsComponent {

  public thesis: Thesis = <Thesis> {text: []};
  public title: string = 'Neue These';
  public languages: Array<Language> = Language.defaultLanguages;
  public language: string = this.languages[0].code;
  public isUsedInQuestionChain: boolean = false;

  private converter: Showdown.Converter = new Showdown.Converter();
  public showMarkdownOutput: Array<boolean> = [];
  private markdownOutput: Array<any> = [];

  constructor(private detailsService: ThesisDetailsService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    this.converter.setFlavor('github')
  }

  public ngOnInit(): void {
    this.activatedRoute.params.map((routeParameters: Params) => {
      return routeParameters['thesisId'];
    })
    .subscribe((thesisId: string) => {
      if (!thesisId) {
        return;
      }

      this.title = 'These bearbeiten';
      this.detailsService.getThesisById(thesisId)
        .subscribe((thesis: Thesis) => {
          this.thesis = thesis;
          this.thesis.text.forEach((tip, i) => {
            this.showMarkdownOutput[i] = true;
            this.markdownOutput[i] = {de: '', en: ''};
            this.updateMarkdown(i);
          });
        });
    });
  }

  public setLanguage(language: Language): void {
    this.language = language.code;
    this.thesis.text.forEach((tip, i) => {
      this.updateMarkdown(i);
    });
  }

  public saveThesis(): void {
    this.detailsService.saveThesis(this.thesis)
      .subscribe((savedThesis: Thesis) => {
        this.router.navigateByUrl('/theses');
      });
  }

  public updateThesis(): void {
    this.detailsService.updateThesis(this.thesis)
      .subscribe((updatedThesis: Thesis) => {
        this.router.navigateByUrl('/theses');
      });
  }

  public addEntry(): void {
    this.thesis.text.unshift(TranslatedText.createEmptyInstance());
  }

  public deleteEntry(tipIndex: number): void {
    this.thesis.text.splice(tipIndex, 1);
  }

  public get submitButtonText(): string {
    return this.thesis._id ? 'Speichern' : 'Erstellen';
  }

  public onSubmit(): void {
    if (this.thesis._id) {
      return this.updateThesis();
    }
    return this.saveThesis();
  }

  public trackByIndex(index: number, value: number): number {
    return index;
  }

  private setMarkdownOutput(i: number, value: boolean): void {
    console.log("mark")
    this.showMarkdownOutput[i] = value;
  }

  private updateMarkdown(i): void {
    if ( !this.markdownOutput[i] ) {
      this.markdownOutput[i] = {};
    }
    this.markdownOutput[i][this.language] = this.converter.makeHtml(this.thesis.text[i][this.language]);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/thesis/thesis-details/thesis-details.component.ts